import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_Enhancer = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/image-enhancer',
			name: 'AI Image Enhancer | Enhance Photo Quality to 4K | Lift',
			description:
				'Upscale blurry photos to sharp 4K in one click. Online AI photo enhancer, no watermarks. Try Lift Enhancer now.',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/image-enhancer#product' },
				{ '@id': 'https://liftapp.ai/image-enhancer#howto' },
				{ '@id': 'https://liftapp.ai/image-enhancer#benefits' },
				{ '@id': 'https://liftapp.ai/image-enhancer#faq' },
				{ '@id': 'https://liftapp.ai/image-enhancer#why-lift' },
				{ '@id': 'https://liftapp.ai/image-enhancer#explore-tools' },
				{ '@id': 'https://liftapp.ai/image-enhancer#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/image-enhancer#product',
			name: 'Lift AI Image Enhancer',
			description:
				'Upscale blurry photos to sharp 4K in one click. Online AI photo enhancer, no watermarks. Try Lift Enhancer now.',
			url: 'https://liftapp.ai/image-enhancer',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},

		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/image-enhancer#howto',
			name: 'How to enhance a photo using Lift AI',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your image',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Apply AI enhancements',
					text: 'Let Lift’s AI optimize your image for clarity, brightness, and color balance',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},

		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-enhancer#benefits',
			name: 'Who Can Benefit from Lift AI Image Enhancer?',
			description:
				'Lift AI Image Enhancer helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Anyone who values high-quality visuals',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'E-commerce sellers increasing conversions with sharp product photos',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Social media influencers and content creators boosting engagement',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Photographers fine-tuning lighting and details quickly',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Marketers and businesses elevating branding and ads',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Event planners improving event photos',
				},
				{
					'@type': 'ListItem',
					position: 7,
					name: 'Anyone needing quick yet pro-level visual edits',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.d4ac6242.webp',
				name: 'Stylized portrait and scratch removal',
				description: 'AI-enhanced example showing before/after retouch by Lift',
			},
		},

		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/image-enhancer#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Image Enhancer?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Image Enhancer is a premium online tool that improves photo clarity, colour and resolution up to 4K in a single click.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Image Enhancer work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'AI image enhancer uses a two-step deep-learning process: first, a smart denoiser cleans blur and noise; next, a super-resolution model rebuilds lost pixels, boosts colours and sharpens edges all the way up to crisp 4K. Everything runs in the cloud, so you get pro-level photo quality with one click..',
					},
				},
				{
					'@type': 'Question',
					name: 'Can it fix a blurry or low-quality photo?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Enhancer is trained to recover lost sharpness, reduce noise, and restore color and detail in blurry or low-res images — making them look crisp, clean, and natural again with just one click.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-enhancer#why-lift',
			name: 'Why Choose Lift AI Image Enhancer',
			description:
				'Explore why Lift’s AI image enhancement stands out: professional results, smart AI accuracy, cross-platform support, and affordability.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],

			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.b232b03b.webp',
				name: 'Before and after with Lift',
				description:
					"Example showcasing Lift AI's image enhancement capabilities",
			},
		},

		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-enhancer#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/image-enhancer#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Image Enhancer',
					item: 'https://liftapp.ai/image-enhancer',
				},
			],
		},
	],
};
